export default class ArrayUtils {
  /**
   * Returns a new array with only unique values.
   * @param array
   */
  static distinct<T>(array: T[]): T[] {
    return array.filter(this.isFirstOccurrence);
  }

  static isFirstOccurrence<T>(value: T, index: number, array: T[]): boolean {
    return array.indexOf(value) === index;
  }

  /**
   * Sorts the array based on the provided mapping function and direction.
   * @param array The array to be sorted.
   * @param mapFn A mapping function that extracts a comparable value from each array element. By default, it is the array element by itself.
   * @param direction The sorting direction, 'asc' (default) or 'desc'.
   */
  static sortBy<T, K>(
    array: T[],
    mapFn: (element: T) => K = (value) => value as unknown as K,
    direction: "asc" | "desc" = "asc",
  ): T[] {
    const sortOrder = direction === "asc" ? 1 : -1;
    return array.slice().sort((a, b) => (mapFn(a) > mapFn(b) ? sortOrder : -sortOrder));
  }
}
